import { Box, Grid } from "@mui/material";
import { cloudfrontUrl } from "../../../constants/imageUrl";
import { useState, useEffect, useRef } from "react";
import { PRIMARY_COLOR } from "../../../constants/color";

interface JobListing {
  id: string;
  title: string;
  company: string;
  location: string;
  type: string;
  url: string;
  isNew: boolean;
  platform: "indeed" | "hellowork";
}

export default function Careers() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  const jobListings: JobListing[] = [
    {
      id: "1",
      title: "Employé de cuisine H/F",
      company: "Korean food",
      location: "06700 Saint-Laurent-du-Var",
      type: "Temps plein",
      url: "https://fr.indeed.com/viewjob?jk=3ad87a09b6ec0449&from=shareddesktop_copy",
      isNew: true,
      platform: "indeed",
    },
    {
      id: "2",
      title: "Responsable Point de Vente en Restauration (H/F)",
      company: "SUPERF",
      location: "Nice",
      type: "Temps plein",
      url: "https://fr.indeed.com/viewjob?jk=18c86b7aff339ac7&from=shareddesktop_copy",
      isNew: true,
      platform: "indeed",
    },
    {
      id: "3",
      title: "Equipier polyvalent de Restauration - Street Food coréenne H/F",
      company: "SUPERF",
      location: "Nice",
      type: "Temps plein",
      url: "https://fr.indeed.com/viewjob?jk=ae234a630b89082d&from=shareddesktop_copy",
      isNew: true,
      platform: "indeed",
    },
    {
      id: "4",
      title: "Responsable de Salle / Assistant Manager H/F - Restaurant coréen",
      company: "SUPERF",
      location: "Nice",
      type: "Temps plein",
      url: "https://fr.indeed.com/job/responsable-de-salle-assistant-manager-hf-restaurant-cor%C3%A9en-05edb2687ce0cdbb",
      isNew: true,
      platform: "indeed",
    },
    {
      id: "5",
      title: "Barman - Barmaid à Temps Partiel - Korean Food H/F",
      company: "Korean Street Market",
      location: "Nice",
      type: "Temps partiel",
      url: "https://www.hellowork.com/fr-fr/emplois/71364750.html",
      isNew: true,
      platform: "hellowork",
    },
    {
      id: "6",
      title: "Chef de Cuisine - Responsable de Cuisine H/F",
      company: "Korean Street Market",
      location: "Nice",
      type: "CDI Temps plein",
      url: "https://www.hellowork.com/fr-fr/emplois/72330667.html",
      isNew: true,
      platform: "hellowork",
    },
  ];

  const renderJobCard = (job: JobListing, isMobile: boolean = false) => (
    <div
      key={job.id}
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        padding: isMobile ? "1rem" : "clamp(0.75rem, 2vw, 1.25rem)",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        cursor: "pointer",
        transition: "all 0.3s ease",
        marginBottom: isMobile ? "1rem" : "0",
      }}
      onClick={() => {
        window.open(job.url, "_blank");
      }}
      onMouseEnter={(e) => {
        if (!isMobile) {
          e.currentTarget.style.transform = "translateY(-5px)";
          e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.15)";
        }
      }}
      onMouseLeave={(e) => {
        if (!isMobile) {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.1)";
        }
      }}
      onTouchStart={(e) => {
        if (isMobile) {
          e.currentTarget.style.transform = "translateY(-3px)";
          e.currentTarget.style.boxShadow = "0 6px 25px rgba(0,0,0,0.15)";
        }
      }}
      onTouchEnd={(e) => {
        if (isMobile) {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.1)";
        }
      }}
    >
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "0.75rem",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              backgroundColor:
                job.platform === "indeed" ? "#0073b1" : "#000000",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "12px",
            }}
          >
            <span
              style={{
                color: "white",
                fontWeight: "bold",
                fontSize: job.platform === "indeed" ? "16px" : "12px",
              }}
            >
              {job.platform === "indeed" ? "in" : "HW"}
            </span>
          </div>
          <div>
            <h3
              style={{
                margin: "0",
                color: PRIMARY_COLOR,
                fontSize: "1.1rem",
                fontWeight: "600",
                lineHeight: "1.2",
              }}
            >
              {job.title}
            </h3>
            <p
              style={{
                margin: "2px 0 0 0",
                color: "#666",
                fontSize: "0.85rem",
              }}
            >
              {job.company}
            </p>
          </div>
        </div>

        <div style={{ marginBottom: "1rem" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "6px",
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              style={{ marginRight: "8px", color: "#666" }}
            >
              <path
                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                fill="currentColor"
              />
            </svg>
            <span style={{ color: "#666", fontSize: "0.9rem" }}>
              {job.location}
            </span>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "6px",
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              style={{ marginRight: "8px", color: "#666" }}
            >
              <path
                d="M20 6h-2V4c0-1.11-.89-2-2-2H8c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM8 4h8v2H8V4zm12 15H4V8h16v11z"
                fill="currentColor"
              />
            </svg>
            <span style={{ color: "#666", fontSize: "0.9rem" }}>
              {job.type}
            </span>
          </div>

          {job.isNew && (
            <div
              style={{
                display: "inline-block",
                backgroundColor: "#e8f5e8",
                color: "#2d5a2d",
                padding: "4px 12px",
                borderRadius: "20px",
                fontSize: "0.8rem",
                fontWeight: "500",
              }}
            >
              Nouveau
            </div>
          )}
        </div>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingTop: "0.75rem",
          borderTop: "1px solid #e0e0e0",
        }}
      >
        <span
          style={{
            color: job.platform === "indeed" ? "#0073b1" : "#000000",
            fontSize: "0.9rem",
            fontWeight: "600",
          }}
        >
          {job.platform === "indeed" ? "Voir sur Indeed" : "Voir sur HelloWork"}
        </span>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          style={{ color: job.platform === "indeed" ? "#0073b1" : "#000000" }}
        >
          <path
            d="M7 17L17 7M17 7H7M17 7V17"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <Box ref={sectionRef} sx={{ width: "100%", height: "100%" }}>
      <style>
        {`
          @keyframes slideInLeft {
            from {
              opacity: 0;
              transform: translateX(-100px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
          
          @keyframes slideInRight {
            from {
              opacity: 0;
              transform: translateX(100px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }
          
          .animate-left {
            animation: slideInLeft 0.8s ease-out forwards;
          }
          
          .animate-right {
            animation: slideInRight 0.8s ease-out forwards;
          }
          
          .animate-left-delayed {
            animation: slideInLeft 0.8s ease-out 0.2s forwards;
            opacity: 0;
          }
        `}
      </style>

      {/* Desktop Layout */}
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <Grid container sx={{ height: "100%" }}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "stretch",
                backgroundColor: "#fff",
                height: "100vh",
                maxHeight: "800px",
                minHeight: "600px",
              }}
            >
              {/* Left side - Images */}
              <div
                className={isVisible ? "animate-left" : ""}
                style={{
                  flex: "0 0 70%",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  opacity: isVisible ? 1 : 0,
                  height: "100%",
                }}
              >
                <img
                  src={`${cloudfrontUrl}/about/ksmweb_joinus_03.png`}
                  alt="Careers"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />

                <img
                  src={`${cloudfrontUrl}/about/ksmweb_joinus_02.png`}
                  alt="Careers"
                  className={isVisible ? "animate-left" : ""}
                  style={{
                    position: "absolute",
                    top: "2%",
                    left: "25%",
                    width: "clamp(15%, 20vw, 20%)",
                    height: "auto",
                    zIndex: 2,
                    opacity: isVisible ? 1 : 0,
                  }}
                />
                <img
                  src={`${cloudfrontUrl}/about/ksmweb_joinus_01.png`}
                  alt="Careers"
                  className={isVisible ? "animate-left-delayed" : ""}
                  style={{
                    position: "absolute",
                    top: "2%",
                    left: "3%",
                    width: "clamp(30%, 40vw, 40%)",
                    height: "auto",
                    zIndex: 1,
                    opacity: isVisible ? 1 : 0,
                  }}
                />
              </div>

              {/* Right side - Job Listings */}
              <div
                className={isVisible ? "animate-right" : ""}
                style={{
                  flex: "0 0 30%",
                  display: "flex",
                  flexDirection: "column",
                  padding: "clamp(0.5rem, 2vw, 1rem)",
                  opacity: isVisible ? 1 : 0,
                  boxSizing: "border-box",
                  height: "100%",
                  overflowY: "auto",
                  gap: "1rem",
                }}
              >
                {jobListings.map((job) => (
                  <div
                    key={job.id}
                    className={isVisible ? "animate-right" : ""}
                    style={{
                      display: "flex",
                      alignItems: "stretch",
                      opacity: isVisible ? 1 : 0,
                      flexShrink: 0,
                    }}
                  >
                    {renderJobCard(job, false)}
                  </div>
                ))}
              </div>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Mobile Layout */}
      <Box
        sx={{
          display: { xs: "block", md: "none" },
          backgroundColor: "#fff",
          padding: "1rem",
          position: "relative",
        }}
      >
        <Grid container spacing={1}>
          {/* Top row with images 02 and 01 - closer together */}
          <Grid item xs={6}>
            <Box sx={{ paddingRight: "0.25rem" }}>
              <img
                src={`${cloudfrontUrl}/about/ksmweb_joinus_02.png`}
                alt="Careers"
                className={isVisible ? "animate-left" : ""}
                style={{
                  width: "30%",
                  height: "auto",
                  opacity: isVisible ? 1 : 0,
                  position: "absolute",
                  top: "4%",
                  left: "30%",
                  zIndex: 2,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ paddingLeft: "0.25rem" }}>
              <img
                src={`${cloudfrontUrl}/about/ksmweb_joinus_01.png`}
                alt="Careers"
                className={isVisible ? "animate-left-delayed" : ""}
                style={{
                  width: "50%",
                  height: "auto",
                  opacity: isVisible ? 1 : 0,
                  position: "absolute",
                  top: "5%",
                  left: "0",
                  zIndex: 1,
                }}
              />
            </Box>
          </Grid>

          {/* Bottom row with image 03 full width */}
          <Grid item xs={12}>
            <Box sx={{ paddingTop: "0.5rem" }}>
              <img
                src={`${cloudfrontUrl}/about/ksmweb_joinus_03.png`}
                alt="Careers"
                className={isVisible ? "animate-right" : ""}
                style={{
                  width: "100%",
                  height: "auto",
                  opacity: isVisible ? 1 : 0,
                  paddingTop: "3rem",
                }}
              />
            </Box>
            {jobListings.map((job) => (
              <div
                key={job.id}
                className={isVisible ? "animate-left" : ""}
                style={{
                  marginTop: "2rem",
                  opacity: isVisible ? 1 : 0,
                }}
              >
                {renderJobCard(job, true)}
              </div>
            ))}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
